import { render, staticRenderFns } from "./RowSmallScreen.vue?vue&type=template&id=d4860cbc&"
import script from "./RowSmallScreen.vue?vue&type=script&lang=js&"
export * from "./RowSmallScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4860cbc')) {
      api.createRecord('d4860cbc', component.options)
    } else {
      api.reload('d4860cbc', component.options)
    }
    module.hot.accept("./RowSmallScreen.vue?vue&type=template&id=d4860cbc&", function () {
      api.rerender('d4860cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/files/RowSmallScreen.vue"
export default component.exports